export default __webpack_public_path__ + "no-activity.d78d9a38.png";